module.exports = __webpack_public_path__ + "img/15.5ebf953e.jpg";